import { Col, Nav, Row, Stack } from 'react-bootstrap';
import { NavLink, Outlet, useParams, useLocation } from 'react-router-dom';

import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import {
  getSignleStoredData,
  getStoredDataUsingKey,
  setSingleStoredData,
  setAllStoredData
} from '../../../../../helpers/localStorageHelper';
import { useSelector } from 'react-redux';
import { loggedUser } from '../../../../store/features/authSlice';
const AttendanceNavigation = (props) => {
  const storageKey = getSignleStoredData('attendance_tab');
  useEffect(() => {
    setSingleStoredData('attendance_tab', 'team');
  }, []);
  const [selectedFilterTab, setSelectedFilterTab] = useState(() => {
    const storedValue = getSignleStoredData('attendanceSelectFilterData');
    if (storedValue === null || storedValue === undefined || storedValue === 'not found') {
      return 'pending';
    }
    return storedValue;
  });
  const [currentPage, setCurrentPage] = useState(
    getStoredDataUsingKey(storageKey, 'currentPage', 1)
  );

  const checkLoggedInUser = useSelector(loggedUser);
  const location = useLocation();
  const { t, employeeCanViewTeam, setUpdateSelectedTab } = props;
  const currentURL = location.pathname;
  const navigateArray = [
    {
      label: t('page.attendance_own_tab'),
      link: `/attendance/own`,
      identity: `/own`
    }
  ];
  if (employeeCanViewTeam > 1) {
    navigateArray.push({
      label: t('page.attendance_team_tab'),
      link: `/attendance/team`,
      identity: '/team'
    });
  }
  // Filter tabs option
  const filterTabs = [
    { value: 'pending', label: `${t('page.attendance_filter_tabs_pending')}` },
    { value: 'yesterday', label: `${t('page.attendance_filter_tabs_yesterday')}` },
    { value: 'today', label: `${t('page.attendance_filter_tabs_today')}` },
    { value: 'tomorrow', label: `${t('page.attendance_filter_tabs_tomorrow')}` },
    { value: 'this_week', label: `${t('page.attendance_filter_tabs_this_week')}` },
    { value: 'upcoming', label: `${t('page.attendance_filter_tabs_upcoming_week')}` },
    { value: 'prev_week', label: `${t('page.attendance_filter_tabs_prev_week')}` },
    { value: 'all', label: `${t('page.attendance_filter_tabs_all')}` }
  ];

  // Filter Initialization
  useEffect(() => {
    let userSelecteAttendanceTab = 'own';
    if (currentURL.includes('team')) {
      let teamAttendance = {
        currentPage: currentPage,
        selectedFilterTab: selectedFilterTab
      };
      setAllStoredData('teamAttendance', teamAttendance, false);
      userSelecteAttendanceTab = 'team';
    } else {
      let ownAttendance = {
        currentPage: currentPage,
        selectedFilterTab: selectedFilterTab
      };
      const storageKey = `attendance_${selectedFilterTab}_tab_data`;
      setAllStoredData(storageKey, ownAttendance, false);
    }
    setSingleStoredData('userSelecteAttendanceTab', userSelecteAttendanceTab);
    setSingleStoredData('attendanceSelectFilterData', selectedFilterTab);
  }, [currentPage, selectedFilterTab]);

  return (
    <>
      <Stack className="attendance-nav-wrapper d-flex flex-wrap row-gap-4 flex-md-row justify-content-between align-items-md-center">
        <div className="d-flex flex-column flex-sm-row row-gap-4 align-items-sm-center">
          <div className="page-title">
            <h1 className="title">{t('page.attendance_list_label')}</h1>
          </div>
          <Nav className="custom-tabs">
            {navigateArray.map((navigateObject, index) => (
              <Nav.Item key={index}>
                <NavLink
                  className={
                    currentURL.includes(navigateObject.identity)
                      ? 'active-tab nav-link'
                      : 'nav-link'
                  }
                  to={navigateObject.link}>
                  {navigateObject.label}
                </NavLink>
              </Nav.Item>
            ))}
          </Nav>
        </div>

        <div className="breadcrumb-tabs text-center">
          {filterTabs.map((filter, index) => (
            <>
              <span
                key={index}
                style={
                  filter.value === selectedFilterTab
                    ? { color: '#14804A', fontWeight: '600' }
                    : { cursor: 'pointer' }
                }
                onClick={() => {
                  setSelectedFilterTab(filter.value);
                  setSingleStoredData('attendanceSelectFilterData', filter.value);
                  setUpdateSelectedTab(filter.value);
                  setCurrentPage(1);
                }}>
                {filter.label}
              </span>
              {index < filterTabs.length - 1 && ' | '}
            </>
          ))}
        </div>
      </Stack>
      <Outlet />
    </>
  );
};
AttendanceNavigation.propTypes = {
  t: PropTypes.func
};
export { AttendanceNavigation };
